import { useMemo, useState } from 'react';
import PreviewTabs from './PreviewTabs';
import { TDirectorInfo, TInfoltd, TStep3Branch } from '../../../types';
import NatureOfBusiness from './NatureOfBusiness';
import NamesOfBusiness from './NamesOfBusiness';
import AddressesOfBusiness from './AddressesOfBusiness';
import Button2 from '../../global/Button2';
import ShareholderDetails from './ShareholderDetails';

type TProps = {
  shareholders: TDirectorInfo[];
  directors: TDirectorInfo[];
  step1: TInfoltd;
  branches: TStep3Branch[];
  handleSubmit: () => void;
  loading: boolean;
};
const Preview = ({ directors, shareholders, step1, branches, handleSubmit, loading }: TProps) => {
  const [selected, setSelected] = useState(0);
  const shareholderArr = shareholders?.map((_, index) => `Shareholder ${index + 1} - Details`);
  const directorArr = directors?.map((_, index) => `Director ${index + 1} - Details`);
  const totalLength = shareholderArr.length + directorArr.length;
  const tabs = ['Business Details', ...shareholderArr, ...directorArr];
  const getPerson = useMemo(() => {
    if (selected <= shareholders?.length) {
      const person = shareholders[selected - 1];
      return person;
    } else {
      const person = directors[selected - shareholders.length - 1];
      return person;
    }
  }, [selected]);
  const isLastTab = selected === tabs.length - 1;
  return (
    <div className='mr-[4vw]'>
      <PreviewTabs tabs={tabs} selected={selected} setSelected={setSelected} />
      {selected === 0 ? (
        <>
          <NatureOfBusiness step1={step1} />
          <NamesOfBusiness step1={step1} />
          <AddressesOfBusiness branches={branches} />
        </>
      ) : (
        <>
          <ShareholderDetails shareholder={getPerson} />
        </>
      )}
      <div className='flex justify-between  mt-[40px] mb-7 md:mb-0 items-center'>
        <Button2
          type='submit'
          theme='primary'
          className='!px-3 !gap-1 md:px-3 py-[10px] text-[11px] inline-block outline-none'
          size='sm'
          underline={false}
          disabled={isLastTab}
          onClick={() => {
            if (selected < totalLength) {
              setSelected((prev) => prev + 1);
            } else {
              setSelected(0);
            }
          }}
        >
          NEXT
        </Button2>

        <Button2
          type='submit'
          theme='primary'
          className='!px-3 !gap-1 md:px-3 py-[10px] text-[11px] inline-block outline-none'
          size='sm'
          underline={false}
          onClick={() => {
            handleSubmit();
          }}
          loading={loading}
        >
          SAVE REGISTRATION
        </Button2>
      </div>
    </div>
  );
};

export default Preview;
